import React from "react";
import { type IIconInterface } from "../icon.interface";
import { SvgIcon } from "../SvgIcon";

export const UserIcon: React.FC<IIconInterface> = (props): JSX.Element => {
  return (
    <SvgIcon title="User" viewBox="0 0 21 21" {...props}>
      <path
        d="M10.5804 13.0001C13.4523 13.0001 15.7804 10.672 15.7804 7.8001C15.7804 4.92822 13.4523 2.6001 10.5804 2.6001C7.70849 2.6001 5.38037 4.92822 5.38037 7.8001C5.38037 10.672 7.70849 13.0001 10.5804 13.0001Z"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.69824 17.5492C3.49738 16.166 4.64646 15.0174 6.03005 14.2189C7.41363 13.4204 8.98299 13 10.5805 13C12.178 13 13.7473 13.4204 15.1309 14.219C16.5145 15.0176 17.6635 16.1662 18.4626 17.5494"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
